import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config/apiConfig';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png'; 
import Swal from "sweetalert2";

const ForgottenPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(`${API_URL}/auth/forgot-password`, { email });
            
            Swal.fire({
                icon: 'success',
                title: 'Email envoyé',
                text: 'Si ce compte existe, vous recevrez un lien de réinitialisation.',
                confirmButtonColor: '#1c2143'
            });
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'info',
                title: 'Demande prise en compte',
                text: 'Si l\'adresse est valide, un email a été envoyé.',
                confirmButtonColor: '#1c2143'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-screen w-full flex items-center justify-center bg-[#f8f9fa] relative overflow-hidden font-sans">
            
            {/* DÉCORATION D'ARRIÈRE-PLAN */}
            <div className="absolute top-0 left-0 w-full h-[55%] bg-[#1c2143] skew-y-[-4deg] transform origin-top-left -translate-y-24 z-0 shadow-xl"></div>

            <div className="relative z-10 w-full max-w-md px-6">
                
                <div className="bg-white rounded-2xl shadow-2xl p-10 border-t-4 border-[#Ceaa5b] flex flex-col items-center animate-fade-in-up">
                    
                    {/* Logo */}
                    <div className="mb-6 w-full flex justify-center">
                        <img src={logo} alt="AI Expertys" className="h-20 w-auto object-contain" />
                    </div>

                    <h2 className="text-xl font-bold text-[#1c2143] text-center mb-2">
                        Récupération
                    </h2>
                    <p className="text-gray-400 text-center mb-8 text-sm px-4">
                        Entrez votre email pour recevoir un lien de réinitialisation.
                    </p>

                    <form className="w-full space-y-5" onSubmit={handleSubmit}>
                        <div className="group">
                            <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1 uppercase tracking-wider">Email</label>
                            <input
                                className="block w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-800 placeholder-gray-400 
                                focus:outline-none focus:bg-white focus:ring-2 focus:ring-[#Ceaa5b] focus:border-transparent transition-all duration-200"
                                type="email"
                                required
                                placeholder="nom@aiexpertys.fr"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <button
                            className={`w-full py-3.5 px-4 rounded-lg shadow-lg text-sm font-bold text-white uppercase tracking-wider mt-4
                                ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#1c2143] hover:bg-[#2a3055] hover:shadow-xl'} 
                                transition duration-300 transform active:scale-[0.98] flex justify-center items-center`}
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Envoi...
                                </>
                            ) : 'Envoyer le lien'}
                        </button>
                    </form>

                    {/* Retour connexion CORRIGÉ ICI */}
                    <button 
                        onClick={() => navigate('/login')} 
                        className="mt-6 text-sm text-gray-500 hover:text-[#Ceaa5b] transition-colors flex items-center gap-2"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                        Retour à la connexion
                    </button>
                </div>
                
                <div className="absolute -bottom-16 left-0 w-full text-center">
                     <p className="text-xs text-gray-400 opacity-60">&copy; AI Expertys</p>
                </div>
            </div>
        </div>
    );
};

export default ForgottenPassword;